import React from "react";
import { Button } from "../../components/Button/Button";
import { Icon } from "../../components/Icon/Icon";
import { SectionText } from "../../components/SectionText/SectionText";
import { Header } from "../../components/Header/Header";
import { Footer } from "../../components/Footer/Footer";

export const ErroriTemplate = ({
  iconName,
  titleLabel,
  textLabel,
  buttonLabel,
  linkUrlButton,
}) => {
  return (
    <div className="container-page --bg-yellow mobile-no-btn-fixed">
      <Header customClasses="" />
      <main className="justify-center d-flex flex-column">
        <div className="container --small text-center">
          <Icon name={iconName} customClasses="big-icon" />
        </div>

        <div className="container --medium  mBottom5x">
          <SectionText
            hideText="no"
            titleLabel={titleLabel}
            textLabel={textLabel}
            customClasses="mBottom5x text-center"
          />

          <Button
            type="link"
            linkUrl={linkUrlButton}
            color="active"
            label={buttonLabel}
            uppercase="yes"
            positionIcon="right"
            withIcon="yes"
            customClasses="bigger-Btn --animated-arrow"
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};
